export const FETCH_RULES = 'FETCH_RULES';
export const FETCH_RULES_SUCCESS = 'FETCH_RULES_SUCCESS';
export const FETCH_RULES_FAIL = 'FETCH_RULES_FAIL';

export const FETCH_ENABLED_RULES = 'FETCH_ENABLED_RULES';
export const FETCH_ENABLED_RULES_SUCCESS = 'FETCH_ENABLED_RULES_SUCCESS';
export const FETCH_ENABLED_RULES_FAIL = 'FETCH_ENABLED_RULES_FAIL';

export const FETCH_DISABLED_RULES = 'FETCH_DISABLED_RULES';
export const FETCH_DISABLED_RULES_SUCCESS = 'FETCH_DISABLED_RULES_SUCCESS';
export const FETCH_DISABLED_RULES_FAIL = 'FETCH_DISABLED_RULES_FAIL';

export const UPDATE_RULE = 'UPDATE_RULE';
export const UPDATE_RULE_SUCCESS = 'UPDATE_RULE_SUCCESS';
export const UPDATE_RULE_FAIL = 'UPDATE_RULE_FAIL';

export const UPDATE_RULE_STATUS = 'UPDATE_RULE_STATUS';
export const UPDATE_RULE_STATUS_SUCCESS = 'UPDATE_RULE_STATUS_SUCCESS';
export const UPDATE_RULE_STATUS_FAIL = 'UPDATE_RULE_STATUS_FAIL';
